export default __webpack_public_path__ + "static/media/banner-4.137ebf06.png";